import { useState } from "react";
import {
    Box,
    Text,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    InputGroup,
    InputLeftElement,
    Input,
    Spinner,
    InputRightElement,
} from "@chakra-ui/react";
import { LockIcon, ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

export const NewPasswordForm = ({ onClose, user, newPasswordChallenge }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const navigate = useNavigate();
    const [showPwd, setShowPwd] = useState(false);
    const handleShowPwd = () => setShowPwd(!showPwd);

    const changePasswordHandler = async () => {
        if (errorText) {
            setErrorText("");
        }
        setIsLoading(true);
        try {
            const response = await newPasswordChallenge(user, newPassword)
            console.log(response)
            onClose()
            navigate('/home')
        } catch (error) {
            console.error(error)
            setErrorText(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <ModalContent>
                <ModalHeader>New Password Required!</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Box>
                        <form>
                            <FormControl>
                                <InputGroup mt={2} mb={2}>
                                    <InputLeftElement
                                        pointerEvents="none"
                                        children={<LockIcon />}
                                        color="gray"
                                    />

                                    <Input
                                        type={showPwd ? "text" : "password"}
                                        placeholder="Enter New Password"
                                        autoComplete="true"
                                        value={newPassword}
                                        onChange={(event) => setNewPassword(event.target.value)}
                                    />
                                    <InputRightElement
                                        children={
                                            showPwd ? (
                                                <ViewIcon color="gray" onClick={handleShowPwd} />
                                            ) : (
                                                <ViewOffIcon color="gray" onClick={handleShowPwd} />
                                            )
                                        }
                                    />
                                </InputGroup>
                            </FormControl>

                            <Text fontSize="xs" color="red">
                                {errorText}
                            </Text>
                        </form>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button
                        mt={2}
                        type="submit"
                        size="sm"
                        colorScheme="blue"
                        onClick={changePasswordHandler}
                        disabled={isLoading || !newPassword}
                    >
                        {isLoading ? <Spinner size="sm" mr={2} /> : null}
                        Submit
                    </Button>
                </ModalFooter>
            </ModalContent>
        </>
    )
}
